import type { AxiosPromise, AxiosRequestConfig } from 'axios';
import type * as Generated from './petseo.client';
import type { WithServiceVendorState } from '@petseo/shared';
import { serviceVendorsClient as rawServiceVendorsClient } from './petseo.client';

export * from './petseo.client';

export type ServiceVendorId = string & { readonly __brand: 'ServiceVendorId' };
export type ServiceVendorPhotoId = string & { readonly __brand: 'ServiceVendorPhotoId' };
export type ServiceTypeId = string & { readonly __brand: 'ServiceTypeId' };
export type ServiceVendorServiceId = string & { readonly __brand: 'ServiceVendorServiceId' };
export type ServiceVendorBusinessHoursId = string & { readonly __brand: 'ServiceVendorBusinessHoursId' };
export type ReservationId = string & { readonly __brand: 'ReservationId' };
export type EmployeeId = string & { readonly __brand: 'EmployeeId' };
export type EmployeeScheduleId = string & { readonly __brand: 'EmployeeScheduleId' };
export type EmployeeTimeOffId = string & { readonly __brand: 'EmployeeTimeOffId' };
export type ExternalReservationId = string & { readonly __brand: 'ExternalReservationId' };
export type PetId = string & { readonly __brand: 'PetId' };
export type ClientProfileId = string & { readonly __brand: 'ClientProfileId' };
export type InternalNoteId = string & { readonly __brand: 'InternalNoteId' };

export const createServiceVendorId = (id: string | Generated.ServiceVendorId): ServiceVendorId => id as ServiceVendorId;
export const createServiceVendorPhotoId = (id: string | Generated.ServiceVendorPhotoId): ServiceVendorPhotoId => id as ServiceVendorPhotoId;
export const createServiceTypeId = (id: string | Generated.ServiceTypeId): ServiceTypeId => id as ServiceTypeId;
export const createServiceVendorServiceId = (id: string | Generated.ServiceVendorServiceId): ServiceVendorServiceId => id as ServiceVendorServiceId;
export const createServiceVendorBusinessHoursId = (id: string | Generated.ServiceVendorBusinessHoursId): ServiceVendorBusinessHoursId =>
  id as ServiceVendorBusinessHoursId;
export const createReservationId = (id: string | Generated.ReservationId): ReservationId => id as ReservationId;
export const createEmployeeId = (id: string | Generated.EmployeeId): EmployeeId => id as EmployeeId;
export const createEmployeeScheduleId = (id: string | Generated.EmployeeScheduleId): EmployeeScheduleId => id as EmployeeScheduleId;
export const createEmployeeTimeOffId = (id: string | Generated.EmployeeTimeOffId): EmployeeTimeOffId => id as EmployeeTimeOffId;
export const createExternalReservationId = (id: string | Generated.ExternalReservationId): ExternalReservationId => id as ExternalReservationId;
export const createPetId = (id: string | Generated.PetId): PetId => id as PetId;
export const createClientProfileId = (id: string | Generated.ClientProfileId): ClientProfileId => id as ClientProfileId;
export const createInternalNoteId = (id: string | Generated.InternalNoteId): InternalNoteId => id as InternalNoteId;

type GetServiceVendorResponse = Omit<Generated.GetServiceVendorResponse, 'serviceVendor'> & {
  serviceVendor?: WithServiceVendorState<Generated.ServiceVendorDetailsDto>;
};
type GetServiceVendorsResponse = Omit<Generated.GetServiceVendorsResponse, 'serviceVendors'> & {
  serviceVendors?: WithServiceVendorState<Generated.ServiceVendorDto>[];
};

type ServiceVendorsClientOverrides = {
  getServiceVendorEndpoint: (serviceVendorId: Generated.ServiceVendorId, $config?: AxiosRequestConfig) => AxiosPromise<GetServiceVendorResponse>;
  getServiceVendorsEndpoint: (
    serviceTypeId: Generated.ServiceTypeId | null | undefined,
    name: string | null | undefined,
    page: number,
    elements: number,
    $config?: AxiosRequestConfig
  ) => AxiosPromise<GetServiceVendorsResponse>;
};

export const serviceVendorsClient = rawServiceVendorsClient as unknown as Omit<typeof rawServiceVendorsClient, keyof ServiceVendorsClientOverrides> &
  ServiceVendorsClientOverrides;
